/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const PhoneNumberTelephonySchema = z.enum(["DEFAULT", "CELLULAR", "LANDLINE", "FAX"])
